import type { KeyValue } from 'ngrx-forms';

import type { NGRXProgressiveFormsActions } from '../actions';
import { InactivateFormStepAction } from '../actions';
import type { ProgressiveFormGroupState } from '../state';

export function inactiveReducer<TValue extends KeyValue>(
  state: ProgressiveFormGroupState<TValue>,
  action: NGRXProgressiveFormsActions
): ProgressiveFormGroupState<TValue> {
  if (action.type !== InactivateFormStepAction.TYPE) {
    return state;
  }

  if (action.stepId !== state.id) {
    return state;
  }

  if (state.isInactive) {
    return state;
  }

  return {
    ...state,
    isInactive: true,
    isActive: false,
  };
}
